/**
 * Dakika cinsinden süreyi "X.YY Saat" biçiminde, virgülsüz float olarak döndürür.
 * Örn: 125 → "2.08 Saat", 60 → "2 Saat" değil "1 Saat" (tam değerlerde ondalık atılır).
 * 60 dk altı değerlerde dakika gösterilir (ör. 30 → "0.50 Saat" yerine daha okunur "30 Dakika").
 */
export function formatDurationFloat(minutes?: number | null): string {
  if (minutes == null || !Number.isFinite(minutes) || minutes <= 0) return "-";
  if (minutes < 60) return `${Math.round(minutes)} Dakika`;
  const hours = minutes / 60;
  if (Number.isInteger(hours)) return `${hours} Saat`;
  return `${hours.toFixed(2)} Saat`;
}

/** Hours + minutes alanlarından tek float saat üretir (API response map için). */
export function formatDurationFromParts(
  durationHours?: number | null,
  durationMinutes?: number | null,
): string {
  const h = typeof durationHours === "number" ? durationHours : 0;
  const m = typeof durationMinutes === "number" ? durationMinutes : 0;
  return formatDurationFloat(h * 60 + m);
}
